import { RouteFlownFuelUnit } from '../messages/message-json';
import { FuelUnit } from '@fe/core';

export default class Fuel {
    constructor(
        public value: number,
        public unit: FuelUnit
    ) {}

    static from1BitUnit(value: number, unit: number): Fuel {
        return new Fuel(value, unit === 0 ? FuelUnit.WeighPounds : FuelUnit.VolumeGallons);
    }

    static fromRouteFlown(value: number, unit: RouteFlownFuelUnit | null): Fuel {
        return new Fuel(value, unit === RouteFlownFuelUnit.weightPounds ? FuelUnit.WeighPounds : FuelUnit.VolumeGallons);
    }

    static areEqual(a: Fuel | null, b: Fuel | null): boolean {
        if (!a || !b) {
            return false;
        }
        return a.value === b.value && a.unit === b.unit;
    }

    get routeFlownUnit(): RouteFlownFuelUnit {
        if (this.unit === FuelUnit.VolumeGallons || this.unit === FuelUnit.VolumeLiters) {
            return RouteFlownFuelUnit.volumeGallons;
        }

        return RouteFlownFuelUnit.weightPounds;
    }

    get routeFlownValue() {
        if (this.unit === FuelUnit.VolumeGallons) {
            return this.value;
        }

        if (this.unit === FuelUnit.WeighPounds) {
            return this.value;
        }

        if (this.unit === FuelUnit.WeightKilograms) {
            return this.value * 2.204622622;
        }

        if (this.unit === FuelUnit.VolumeLiters) {
            return this.value / 3.785411803;
        }

        return this.value;
    }
}
